import { render, staticRenderFns } from "./card-applications-partial.vue?vue&type=template&id=5a4523dc"
import script from "./card-applications-partial.vue?vue&type=script&lang=js"
export * from "./card-applications-partial.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports